<template>
  <div class="current-data-wrapper">

<!-- <div  v-for="(item, index) of jiasj" class="silderLI" v-on:click="goBack()">
         <i
           class="iconfont"
           style="font-size: 38px; color: #3696ea;"
         >&#xe634;</i>
         <div  style="font-size: 12px; color: #f39800">刷新</div>
  </div> -->



    <current-data-box v-for="(item, index) of data" :item="item" :index="index" :key="item.key"></current-data-box>
    <transition
      :duration="2000"
      appear
      enter-active-class="animated bounceInUp"
      leave-active-class="animated bounceOutDown"
    >
      <keep-alive>
        <router-view class="child" :current="current"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import CurrentDataBox from "./components/CurrentDataBox";
export default {
  name: "CurrentData",
  props: {
    current: {
      type: String,
      default: ""
    }
  },
  components: { CurrentDataBox },
  data() {
    return {
      jiasj:[1,2,3,4,5,6,7,8,9,10,11],
      data: [],
      transitionName: "slide-right",
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    this.getCurrentDataInfo();
  },
  methods: {

    goBack() {
      //location.reload();
     this.$router.go(0);
    },
    getCurrentDataInfo() {
      // console.log('shijian==' + this.current)
      let postData = {
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token,
        device: this.$route.params.device,
        current: this.current
      };
      this.$axios
        .getCurrentHomePage(this.appType, postData)
        .then(this.getCurrentDataInfoSucc);
    },
    getCurrentDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        const data = res.data;
        this.data = data;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.current-data-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0.23rem 0.1rem 0 0.1rem;
}

.child {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  top: 0;
  left: 0;
}
.silderLI{
  position fixed
  padding 0.1rem
  bottom 4.5rem
  right 0.1rem
  border-radius 0.5rem
  background-color #f7f7f7
  box-shadow 0px 0px 15px #ddd
  text-align center
 z-index: 1
}

</style>



// WEBPACK FOOTER //
// src/pages/current-data/CurrentData.vue